import { Component, Injector,  ViewChild } from '@angular/core';
import { EmailFamilyTreeNode } from './email-family-tree-node.model';
import { EmailFamilyFlatNode } from './email-family-flat-node.model';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTree, MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { EmailFamilyService } from '@services/email-family.service';
import { RelatedTabBaseComponent } from '../related-tab-base.component';
import { takeUntil } from 'rxjs';
import { EmailType } from '@models/email-type.model';
import { DocViewerContextDoc } from '@models/ui/doc-viewer-context-doc.model';

@Component({
    selector: 'lex-email-family-context-panel',
    templateUrl: './email-family-context-panel.component.html',
    styleUrls: ['./email-family-context-panel.component.scss'],
    standalone: false
})
export class EmailFamilyContextPanelComponent extends RelatedTabBaseComponent {
  public _transformer = (node: EmailFamilyTreeNode, level: number) => {
		const expandable = node.children && node.children.length > 0;
		return {
			expandable: expandable,
			name: node.name,
			level: level,
			docId: node.doc.docId
		};
	};
	public emailFamilyTreeControl = new FlatTreeControl<EmailFamilyFlatNode>(node => node.level, node => node.expandable);
	public emailFamilyTreeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
	public emailFamilyDataSource = new MatTreeFlatDataSource(this.emailFamilyTreeControl, this.emailFamilyTreeFlattener);
	public emailFamilyHasChild = (_: number, node: EmailFamilyFlatNode) => node.expandable;
	public pointerDocId: string = '';
	public isSingleNode: boolean = false; 
	@ViewChild(MatTree) emailFamilyTree: MatTree<EmailFamilyFlatNode>;

	constructor(
		private emailFamilyService: EmailFamilyService,
		private injector: Injector
	) {
		super(injector);
		this.docViewerStore.currentDocument$.pipe(
			takeUntil(this.destroy$)
		).subscribe(() => this.loadEmailFamily());
	}
	public get hasData() {
		return this.emailFamilyDataSource.data && this.emailFamilyDataSource.data.length > 0;
	}

	public toDocContext(node: EmailFamilyFlatNode): DocViewerContextDoc {
		const item = new DocViewerContextDoc();
		item.docId = node.docId
		item.docTitle = node.name;
		item.displayType = node.level === 0 ? 'email' : 'attachment';
		return item;
	}

	private loadEmailFamily() {
		if (this.currentDocumentSnapshot.emailType.value === EmailType.Native.value) {
			this.emailFamilyDataSource.data = [];
		} else {
			this.emailFamilyService.get(this.currentDocumentSnapshot.emailFamilyId)
				.subscribe((treeNode: EmailFamilyTreeNode) => {
					this.isSingleNode = (treeNode.children && treeNode.children.length > 0) ? false : true;  
					this.emailFamilyDataSource.data = [treeNode];
					this.emailFamilyTree.treeControl.expandAll();
				});
		}
	}

}
